import { render, staticRenderFns } from "./tableExport.vue?vue&type=template&id=28e5baf7&"
import script from "./tableExport.vue?vue&type=script&lang=js&"
export * from "./tableExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports